import React from 'react';

const Watermark = ({ position = 'bottom-right', opacity = 0.3, showSage = false }) => {
  const positionClasses = {
    'bottom-right': 'bottom-4 right-4',
    'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2',
    'bottom-left': 'bottom-4 left-4',
    'top-right': 'top-4 right-4',
    'center': 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
  };

  if (showSage) {
    return (
      <div 
        className={`fixed ${positionClasses[position]} z-0 pointer-events-none`}
        style={{ opacity }}
      >
        <img 
          src="/sage-transparent.png" 
          alt="Sage watermark" 
          className="w-96 h-96 object-contain opacity-20"
        />
      </div>
    );
  }

  return (
    <div 
      className={`fixed ${positionClasses[position]} z-50 pointer-events-none`}
      style={{ opacity }}
    >
      <div className="flex items-center gap-2 bg-white/5 backdrop-blur-sm px-3 py-2 rounded-full border border-white/10">
        <div className="w-6 h-6 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center">
          <span className="text-white text-xs font-bold">T</span>
        </div>
        <span className="text-white text-xs font-semibold tracking-wide">Taraanaya</span>
      </div>
    </div>
  );
};

export default Watermark;